import { render, staticRenderFns } from "./inherit.vue?vue&type=template&id=1ebe4533&scoped=true&"
import script from "./inherit.vue?vue&type=script&lang=js&"
export * from "./inherit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebe4533",
  null
  
)

export default component.exports